<template>
  <div id="report">
    <div class="loading">
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
    <Header></Header>
    <Home></Home>
  </div>
</template>

<script>
import Home from "./Home.vue";
import Header from "../components/Header/Header";

export default {
  name: "Report",
  components: {
    Header,
    Home
  }
};
</script>

<style>
@import "../style/_normalize.scss";
.dp-input {
  width: -webkit-fill-available !important;
}
#report {
  background-color: #f5f5f5;
  justify-content: space-around;
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
</style>
